import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';

export const globalAdminFieldSchemeEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-jira-admin-pages-field-scheme" */ './src/ui/FieldSchemeApp.tsx'
			),
	),
	getPreloadProps: ({ context: { match } }: EntryPointRouteParams) => ({
		extraProps: {
			schemeId: match.params?.schemeId || '',
		},
	}),
});
